import React from 'react';
import {Helmet} from "react-helmet";
import { RedocStandalone } from 'redoc';

const Sip = () => {
  return (
    <React.Fragment>
        <RedocStandalone specUrl="/illuma-shield-sip-api-v1.1.yaml" options={{
            theme: {
            typography: {
                fontSize: '1rem'
            },
            colors: {
                primary: {
                main: '#263238'
                }
            }
            },
            jsonSampleExpandLevel: 'all'
        }} />
        <Helmet>
            <meta charSet="utf-8" />
            <title>SIP API - Illuma Shield</title>
            <link rel="canonical" href="https://docs.illuma-labs.com/api/sip" />
            <meta name="description" content="The Illuma Shield SIP API can be used by external applications to manage the verification process."/>
        </Helmet>
    </React.Fragment>
  );
};

export default Sip;
